

























































































































import Vue from 'vue'
import { AbilityAction, AbilitySubject } from '@/abilitiesByRole'
import './InputDetails.scss'
import QualityLabel from '@/components/QualityLabel'
import { srtInputLine, srtState } from '@/helpers/statusHelper'
import { Stream } from '@/types/streams'
import { Dropdown, DropdownItem, DropdownMenu, Option, Select } from 'element-ui'
import moment from 'moment'
import { isEqual } from 'lodash'
import { Cast } from '@/types/casts'
import helpers from '@/helpers'
import LibratoChart, { LibratoChartIds } from '../LibratoChart'
export default Vue.extend({
  name: 'InputDetails',
  props: {
    streamName: {
      type: String,
      required: true
    },
    streamKey: {
      type: String,
      required: false
    },
    castInfo: {
      type: Object as () => Partial<Cast> | undefined,
      required: false
    },
    stream: {
      type: Object as () => Stream,
      required: false
    },
    qualityLabel: {
      type: Object || String,
      required: false
    },
    fpsLabel: {
      type: String,
      required: false
    },
    streamurl: {
      type: String,
      required: false
    },
    k360eventId: {
      type: Number,
      required: true
    },
    feedNames: {
      type: Array as () => string[],
      required: false,
    }
  },
  data: () => ({
    chartDuration: 1800, // seconds
    chartsVisible: true,
    selectedFeedName: '',
  }),
  watch: {
    feedNames (newArray, oldArray) {
      if (isEqual(newArray, oldArray)) {
        return
      }
      // default last one
      this.selectedFeedName = (newArray.length) ? newArray[newArray.length - 1] : ''
    }
  },
  mounted () {
    // default last one
    this.selectedFeedName = (this.feedNames && this.feedNames.length) ? this.feedNames[this.feedNames.length - 1] : ''
  },
  computed: {
    chartIdMixerBitrates (): LibratoChartIds {
      return LibratoChartIds.MIXER_BITRATES
    },
    chartIdMixerBuffers (): LibratoChartIds {
      return LibratoChartIds.MIXER_BUFFERS
    },
    chartIdClockOffets (): LibratoChartIds {
      return LibratoChartIds.INGEST_CLOCK_OFFSET
    },
    chartIdSRTBitrates (): LibratoChartIds {
      return LibratoChartIds.SRT_BITRATE
    },
    chartIdSRTRoundTrip (): LibratoChartIds {
      return LibratoChartIds.SRT_ROUDNTRIP
    },
    durationLabel (): string {
      return moment
        .duration(this.chartDuration, "seconds")
        .humanize()
        .replace('an', '')
    },
    canDoOps (): boolean {
      return this.$can(AbilityAction.Do, AbilitySubject.Ops)
    },
    chartQuery (): string {
      // query used by librato charts
      return `*${this.k360eventId}.${this.selectedFeedName}`
    },
    chartWidth (): number {
      return 620
    },
    haveSrt (): boolean{
      return (this.stream !== undefined && this.stream.srt_info !== undefined)
    },
    srtInputLineStr (): string {
      return srtInputLine(this.stream)
    },
    srtStateStr (): string {
      return srtState(this.stream)
    },
    srtLibratoStreamIdentifier (): string {
      const srt_info = this.stream.srt_info
      if(srt_info !== undefined) {
        const streamId = this.stream.id
        const nimbleserver= srt_info.nimbleserver
        const port = srt_info.port
        const id = `${streamId}.${nimbleserver}.${port}`
        return id
      } else {
        // this is just to please type inference: haveSrt === true
        return 'never_happens'
      }
    },
    castIsActive (): boolean {
      return !this.castInfo || helpers.isActiveCast(this.castInfo)
    },
  },
  methods: {
    setChartDuration (duration: number) {
      this.chartDuration = duration
      this.forceChartUpdate()
    },
    forceChartUpdate () {
      // force redraw of Librato Charts (retrigger script)
      this.chartsVisible = false
      setTimeout(() => {
        this.chartsVisible = true
      }, 10)
    },
    openMetricsUrl (feedName) {
      window.open(this.metricsurl(feedName), '_blank')
    },
    metricsurl (feedName) {
      this.selectedFeedName = feedName
      return this._metricsurl(encodeURI(this.chartQuery))
    },
    _metricsurl (chartQuery) {
      const libratoSpace = 62842
      const start_time = this.castInfo!.start_date.seconds
      const end_time = this.castInfo!.end_date.seconds
      const duration = end_time - start_time
      return `https://metrics.librato.com/s/spaces/${libratoSpace}?duration=${duration}&end_time=${end_time}&source=${chartQuery}`
    },
  },
  components: {
    QualityLabel,
    LibratoChart,
    'el-select': Select,
    'el-option': Option,
    'el-dropdown': Dropdown,
    'el-dropdown-menu': DropdownMenu,
    'el-dropdown-item': DropdownItem,
  }
})
